import { useApolloClient } from "@apollo/client";
import { REDIRECT_PARAM } from "core/consts";
import { getQueryIntVariable, getQueryVariable } from "core/model/utils/urls";
import CareproviderAuthPage from "dsl/ecosystems/CareproviderAuthPage";
import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useLoggedCareproviderId } from "reduxentities/hooks";
import { ReceiverContext } from "..";
import { resolvePostAuthRedirectPath } from "./helpers";

export function AuthRoutes({ context }: { context: ReceiverContext }) {
  const apollo = useApolloClient();
  const location = useLocation();
  const redirectTo = getQueryVariable(location.search, REDIRECT_PARAM);
  const careproviderIdFromUrl = getQueryIntVariable(
    location.search,
    "careproviderid",
  );
  const careproviderIdFromStore = useLoggedCareproviderId();
  const resolvedCareproviderId = parseInt(
    (careproviderIdFromUrl || careproviderIdFromStore || -1).toString(),
  );
  const isAuthenticated = context.checkAuth(resolvedCareproviderId, apollo);

  const RedirectTo = useMemo(function redirecter() {
    return function redirect({
      careproviderId,
      noParams = false,
      useDefault = false,
    }: {
      careproviderId: number;
      noParams?: boolean;
      useDefault?: boolean;
    }) {
      let customRedirectPath = redirectTo;
      if (customRedirectPath && noParams) {
        customRedirectPath = customRedirectPath.split("?")[0];
      }
      const to = resolvePostAuthRedirectPath({
        customRedirectPath,
        loggedInCareproviderId: careproviderId,
        useDefaultRedirect: useDefault,
      });
      return <Navigate replace to={to} />;
    };
  }, []);

  return isAuthenticated ? (
    <RedirectTo
      careproviderId={careproviderIdFromStore ?? resolvedCareproviderId}
    />
  ) : (
    <CareproviderAuthPage
      careproviderId={careproviderIdFromUrl}
      RedirectTo={RedirectTo}
    />
  );
}
